var React = require('react');

function WatchChurch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5625 16.5312C13.0391 16.5312 16.7266 12.8359 16.7266 8.35938C16.7266 3.88281 13.0312 0.195312 8.5625 0.195312C4.08594 0.195312 0.398438 3.88281 0.398438 8.35938C0.398438 12.8359 4.08594 16.5312 8.5625 16.5312ZM8.5625 14.6953C5.05469 14.6953 2.24219 11.8672 2.24219 8.35938C2.24219 4.85156 5.04688 2.03125 8.5625 2.03125C12.0703 2.03125 14.8906 4.85156 14.8984 8.35938C14.8984 11.8672 12.0703 14.6953 8.5625 14.6953ZM11.6172 8.8125C11.9531 8.61719 11.9453 8.13281 11.6172 7.9375L7.08594 5.27344C6.73438 5.07031 6.28125 5.25 6.28125 5.64062V11.1016C6.28125 11.4922 6.71094 11.6797 7.08594 11.4609L11.6172 8.8125Z","fill":"white"}));
}

WatchChurch.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = WatchChurch;

WatchChurch.default = WatchChurch;
